import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { ContentWrapper, ModalAlert } from 'components';
export function SaveOrCancel({ actionCancel, actionSave, close }) {

  const [isActive, setIsActive] = useState(false)

  const wantCancel = () => {
    if(close) close();
    setIsActive(!isActive);
  }

  const closeModal = (data) => {
    setIsActive(data);
  }

  return (
    <ContentWrapper class={"d-flex align-items-center"}>
      <Button onClick={wantCancel} color="secundary" className="px-4">
        Cancelar
    </Button>
      <Button onClick={actionSave} color="primary" className="px-4">
        Salvar
    </Button>
    <ModalAlert isActive={isActive} isClose={closeModal} path={actionCancel} />
    </ContentWrapper>
  );
}
